import { trackContact } from "@/utils/tracking";
import { getWhatsAppLink } from "@/utils/whatsapp";
import { Link } from "react-router-dom";
import { MessageCircle, FileText } from "lucide-react";

export function FloatingBottomBar() {
  const handleWhatsAppClick = () => {
    trackContact("whatsapp_mobile_bar");
  };

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg flex items-center justify-around px-4 py-3 safe-area-pb">
      <a
        href={getWhatsAppLink()}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleWhatsAppClick}
        className="flex items-center gap-2 bg-[#25D366] text-white px-4 py-2.5 rounded-lg font-medium text-sm flex-1 justify-center mr-2"
      >
        <MessageCircle className="w-4 h-4" />
        WhatsApp Us
      </a>
      <Link
        to="/free-school-branding-audit"
        className="flex items-center gap-2 bg-[#e85a1f] text-white px-4 py-2.5 rounded-lg font-medium text-sm flex-1 justify-center"
      >
        <FileText className="w-4 h-4" />
        Get Quote
      </Link>
    </div>
  );
}
